export const global = {
    api_url: "https://api.aeronautfans.com/api/",
    //api_url: "http://localhost:3007/api/",
    cfm_to_cms_converter : 2118.88,
    fan_velocity_pressure : 0.6,
    angles: [45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70],
    vfd_constant: 1.025,
    vfd_eff: 97.5,
    torque_constant: 9.5488,
    fandata_api_url: "https://fanapi.aeronautfans.com/",
    //fandata_api_url: "http://13.234.30.175/",
    web_url: "https://portal.aeronautfans.com/",
    //web_url: "http://82.165.108.42:8001/",
}